import React, { useEffect, useState } from "react";
import CView from "./CView";
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import handleSaveLocation from "./Api/handelSaveLocation";
import handleGetLocation from "./Api/handelGetLocation";
import ShimmerText from "../../components/ShimmerText";

function CChatBox1() {
  const { userId, botID, reranking, queryexpanstion } = useParams();

  const default_bot_ui = {
    name: "Chat with Us",
    logo: null,
    outerFrameColor: "#000000",
    chatheadingColor: "#fffffff",
    usermsgcolor: "#000000",
    usermsgtxtcolor: "#ffffff",
    userdetailsform: false,
    usermobno: true,
    formbgcolor: "#000000",
    formtxtcolor: "#ffffff",
    forminputtxtcolor: "#000000",
    botintro: "Hello there! 👋 It is so nice to chat with you!",
    botleadques:
      "Before we get started, could you please provide me information about you by filling out the form.",
    botthankyou: "Thank you for providing the following details.",
    botgenthankyou: "Appreciate your time. Have a wonderful day ahead!",
    refpdftext: true,
  };

  const [templeteQues, setTempleteQues] = useState([]);
  const [cosui, setCosui] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCustomUI = async () => {
      try {
        const uri = `${process.env.REACT_APP_SERVER}/bot/chatappui?bot_id=${botID}`;

        const option = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const res = await fetch(uri, option);
        const data = await res.json();
        if (data) {
          setCosui({
            name: data?.bot[0]?.ui?.BotName || default_bot_ui.name,
            logo: data?.bot[0]?.ui?.BotLogoUrl || default_bot_ui.logo,
            outerFrameColor:
              data?.bot[0]?.ui?.OuterFrameColor ||
              default_bot_ui.outerFrameColor,
            chatheadingColor:
              data?.bot[0]?.ui?.BotNameHeadingTxtColor ||
              default_bot_ui.chatheadingColor,
            formbgcolor:
              data?.bot[0]?.ui?.FormBgColor || default_bot_ui.formbgcolor,
            formtxtcolor:
              data?.bot[0]?.ui?.FormHeadingTxtColor ||
              default_bot_ui.formtxtcolor,
            forminputtxtcolor:
              data?.bot[0]?.ui?.FormInputTxtColor ||
              default_bot_ui.forminputtxtcolor,
            usermsgcolor:
              data?.bot[0]?.ui?.UserMessagebgColor ||
              default_bot_ui.usermsgcolor,
            usermsgtxtcolor:
              data?.bot[0]?.ui?.UserMessageTextColor ||
              default_bot_ui.usermsgtxtcolor,
            userdetailsform:
              data?.bot[0]?.ui?.FormSkipButton ??
              default_bot_ui.userdetailsform,
            usermobno:
              data?.bot[0]?.ui?.FormMobileButton ?? default_bot_ui.usermobno,
            botintro:
              data?.bot[0]?.ui?.GenralIntroFromBot || default_bot_ui.botintro,
            botleadques:
              data?.bot[0]?.ui?.BotMessageBeforeUserDetailsForm ||
              default_bot_ui.botleadques,
            botthankyou:
              data?.bot[0]?.ui?.BotMessageAfterGettingDetailsForm ||
              default_bot_ui.botthankyou,
            botgenthankyou:
              data?.bot[0]?.ui?.GenralThankyouMessageToEndChat ||
              default_bot_ui.botgenthankyou,
            refpdftext: data?.bot[0]?.ui?.refpdftext === false ? false : true,
          });
          setTempleteQues(data?.bot[0]?.templeQues || []);
        }
      } catch (error) {
        console.error("Failed to fetch custom UI:", error);
        setCosui(default_bot_ui);
      } finally {
        setLoading(false);
      }
    };

    const fn = async () => {
      const storedVisitorId = localStorage.getItem("visitor_id") || null;
      const savedLocation = localStorage.getItem("savedLocation") || false;
      if (!storedVisitorId) {
        const newVisitorId = uuidv4();
        localStorage.setItem("visitor_id", newVisitorId);
      }

      if (savedLocation === false) {
        const data = await handleGetLocation();
        await handleSaveLocation(userId, botID, data);
        localStorage.setItem("savedLocation", true);
      }
    };

    fn();
    fetchCustomUI();
  }, [botID]);

  return (
    <div className="w-screen h-dvh max-h-dvh flex flex-1 fixed glacial-indiffernces ">
      {loading ? (
        <div className="w-full h-full flex justify-center items-center font-bold">
          <ShimmerText />
        </div>
      ) : (
        <CView
          cosui={cosui}
          botlogourl={cosui.logo}
          userId={userId}
          botID={botID}
          reranking={reranking}
          queryexpanstion={queryexpanstion}
          templeteQues={templeteQues}
        />
      )}
    </div>
  );
}

export default CChatBox1;
